import { render, staticRenderFns } from "./progress_bar.vue?vue&type=template&id=56d4c20c&scoped=true"
import script from "./progress_bar.vue?vue&type=script&lang=js"
export * from "./progress_bar.vue?vue&type=script&lang=js"
import style0 from "./progress_bar.vue?vue&type=style&index=0&id=56d4c20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4c20c",
  null
  
)

export default component.exports